<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">工资信息</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">至</span>
            <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">状态：</span>
            <Select v-model="status" :datas="statusOptions" keyName="key" titleName="title" :deletable="true" style="width:120px" @change="loadList"></Select>
            <input type="text" v-model="keyword" placeholder="员工姓名" class="input-small" @keyup.enter="loadList">
            <Button size="s" @click="loadList">刷新</Button>
            <span class="flex-spacer"></span>
            <Button color="primary" size="s" @click="showGen = true">生成工资表</Button>
            <Button size="s" @click="exportData">导出</Button>
            <Button size="s" @click="showCustom = true">自定义工资项</Button>
            <Button size="s" @click="notOpen('工资条二维码')">工资条二维码</Button>
        </div>
        <div class="h-panel-body">
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:90px">期间</th>
                    <th style="width:80px">状态</th>
                    <th class="num">应发工资</th>
                    <th class="num">免税收入</th>
                    <th class="num">年金</th>
                    <th class="num">商业健康保险</th>
                    <th class="num">税延养老保险</th>
                    <th class="num">其他</th>
                    <th class="num">养老保险</th>
                    <th class="num">医疗保险</th>
                    <th class="num">工伤保险</th>
                    <th class="num">失业保险费</th>
                    <th class="num">公积金缴纳</th>
                    <th class="num">个人所得税</th>
                    <th class="num">实发工资</th>
                    <th style="width:90px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datas" :key="item.id">
                    <td>{{item.period}}</td>
                    <td>{{item.status === 1 ? '已生成凭证' : '草稿'}}</td>
                    <td class="num">{{item.grossPay|numFormat}}</td>
                    <td class="num">{{item.taxFreeIncome|numFormat}}</td>
                    <td class="num">{{item.annuity|numFormat}}</td>
                    <td class="num">{{item.commercialHealth|numFormat}}</td>
                    <td class="num">{{item.taxDeferred|numFormat}}</td>
                    <td class="num">{{item.other|numFormat}}</td>
                    <td class="num">{{item.pension|numFormat}}</td>
                    <td class="num">{{item.medical|numFormat}}</td>
                    <td class="num">{{item.injury|numFormat}}</td>
                    <td class="num">{{item.unemployment|numFormat}}</td>
                    <td class="num">{{item.housingFund|numFormat}}</td>
                    <td class="num">{{item.personalIncomeTax|numFormat}}</td>
                    <td class="num strong">{{item.netPay|numFormat}}</td>
                    <td class="actions">
                        <span @click="edit(item)">编辑</span>
                        <span @click="remove(item)">删除</span>
                    </td>
                </tr>
                <tr v-if="!datas.length"><td :colspan="16" class="text-center padding">暂无数据</td></tr>
                <tr class="total" v-if="datas.length">
                    <td :colspan="2" align="center">小计</td>
                    <td class="num">{{sum('grossPay')|numFormat}}</td>
                    <td class="num">{{sum('taxFreeIncome')|numFormat}}</td>
                    <td class="num">{{sum('annuity')|numFormat}}</td>
                    <td class="num">{{sum('commercialHealth')|numFormat}}</td>
                    <td class="num">{{sum('taxDeferred')|numFormat}}</td>
                    <td class="num">{{sum('other')|numFormat}}</td>
                    <td class="num">{{sum('pension')|numFormat}}</td>
                    <td class="num">{{sum('medical')|numFormat}}</td>
                    <td class="num">{{sum('injury')|numFormat}}</td>
                    <td class="num">{{sum('unemployment')|numFormat}}</td>
                    <td class="num">{{sum('housingFund')|numFormat}}</td>
                    <td class="num">{{sum('personalIncomeTax')|numFormat}}</td>
                    <td class="num">{{sum('netPay')|numFormat}}</td>
                    <td></td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- 生成工资表 -->
        <Modal v-model="showGen" hasCloseIcon>
            <div slot="header">生成工资表</div>
            <Form v-width="420" :labelWidth="100">
                <FormItem label="期间">
                    <DatePicker v-model="gen.period" type="month" format="yyyy-MM"></DatePicker>
                </FormItem>
                <FormItem label="员工">
                    <Select v-model="gen.employeeIds" :datas="employeeOptions" keyName="id" titleName="name" multiple :deletable="true" style="width:100%"></Select>
                </FormItem>
                <p class="tip">不选择员工则对全部员工生成工资记录。</p>
            </Form>
            <div class="text-center margin-top">
                <Button color="primary" @click="doGenerate" :loading="loading">生成</Button>
                <Button @click="showGen=false">取消</Button>
            </div>
        </Modal>

        <!-- 自定义工资项 -->
        <Modal v-model="showCustom" type="drawer-right" hasCloseIcon>
            <div slot="header">自定义工资项</div>
            <div class="margin-bottom">
                <Button color="primary" size="s" @click="addCustom">新增工资项</Button>
            </div>
            <table class="grid">
                <thead><tr><th>名称</th><th>类型</th><th>默认值</th><th>操作</th></tr></thead>
                <tbody>
                <tr v-for="c in customItems" :key="c.id">
                    <td>{{c.name}}</td>
                    <td>{{c.itemType === 2 ? '减项(扣款)' : '增项(应发)'}}</td>
                    <td class="num">{{c.defaultValue|numFormat}}</td>
                    <td class="actions"><span @click="editCustom(c)">编辑</span><span @click="removeCustom(c)">删除</span></td>
                </tr>
                <tr v-if="!customItems.length"><td :colspan="4" class="text-center padding">暂无数据</td></tr>
                </tbody>
            </table>

            <Modal v-model="showCustomForm" :type="null">
                <div slot="header">{{customForm.id?'编辑':'新增'}}工资项</div>
                <Form v-width="380" :labelWidth="90" :model="customForm">
                    <FormItem label="名称"><input type="text" v-model="customForm.name"></FormItem>
                    <FormItem label="类型">
                        <Select v-model="customForm.itemType" :datas="itemTypeOptions" keyName="key" titleName="title" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="默认值"><NumberInput v-model="customForm.defaultValue" :precision="2" :min="0"></NumberInput></FormItem>
                    <FormItem label="公式说明"><input type="text" v-model="customForm.formula"></FormItem>
                    <FormItem label="备注"><input type="text" v-model="customForm.remark"></FormItem>
                </Form>
                <div class="text-center margin-top">
                    <Button color="green" @click="saveCustom" :loading="loading">保存</Button>
                    <Button @click="showCustomForm=false">取消</Button>
                </div>
            </Modal>
        </Modal>
    </app-content>
</template>

<script>
import { exportXls } from '../../js/common/export';

export default {
    name: 'SalaryInfo',
    data() {
        const ym = this.curYm();
        return {
            datas: [], p1: ym, p2: ym, keyword: '', status: null,
            statusOptions: [{ key: 0, title: '草稿' }, { key: 1, title: '已生成凭证' }],
            showGen: false, showCustom: false, showCustomForm: false, loading: false,
            gen: { period: ym, employeeIds: [] },
            employeeOptions: [], customItems: [], itemTypeOptions: [{ key: 1, title: '增项(应发)' }, { key: 2, title: '减项(扣款)' }],
            customForm: this.emptyCustom()
        };
    },
    methods: {
        curYm() { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}`; },
        emptyCustom() { return { id: null, name: '', itemType: 1, defaultValue: 0, formula: '', remark: '' }; },
        fmtPeriod(d) { if (!d) return ''; if (typeof d === 'string') return d; return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; },
        sum(f) { return this.datas.reduce((s, d) => s + Number(d[f] || 0), 0); },
        loadList() {
            this.$api.salary.salary.list({
                p1: this.fmtPeriod(this.p1), p2: this.fmtPeriod(this.p2),
                keyword: this.keyword || undefined, status: this.status
            }).then(({ data }) => { this.datas = data || []; });
        },
        edit(item) {
            this.$api.salary.salary.load(item.id).then(() => {
                this.$Message.info('工资明细编辑：可在「员工信息」维护基础数据后重新生成');
            });
        },
        remove(item) {
            this.$Confirm('确认删除该工资记录?').then(() => {
                this.$api.salary.salary.delete(item.id).then(() => { this.loadList(); this.$Message.success('已删除'); });
            });
        },
        doGenerate() {
            this.loading = true;
            this.$api.salary.salary.generate({
                period: this.fmtPeriod(this.gen.period),
                employeeIds: this.gen.employeeIds && this.gen.employeeIds.length ? this.gen.employeeIds : undefined
            }).then(({ msg }) => {
                this.loading = false; this.showGen = false; this.loadList();
                this.$Message.success(msg || '已生成');
            }).catch(() => { this.loading = false; });
        },
        loadCustom() { this.$api.salary.customItem.list().then(({ data }) => { this.customItems = data || []; }); },
        addCustom() { this.customForm = this.emptyCustom(); this.showCustomForm = true; },
        editCustom(c) { this.customForm = Object.assign(this.emptyCustom(), c); this.showCustomForm = true; },
        saveCustom() {
            if (!this.customForm.name) { this.$Message.error('请填写名称'); return; }
            const p = Object.assign({}, this.customForm);
            this.loading = true;
            this.$api.salary.customItem[p.id ? 'update' : 'save'](p).then(() => {
                this.loading = false; this.showCustomForm = false; this.loadCustom();
                this.$Message.success('保存成功');
            }).catch(() => { this.loading = false; });
        },
        removeCustom(c) {
            this.$Confirm('确认删除该工资项?').then(() => {
                this.$api.salary.customItem.delete(c.id).then(() => { this.loadCustom(); });
            });
        },
        exportData() {
            this.$api.salary.salary.list({ p1: '0000-01', p2: '9999-12' }).then(({ data }) => {
                const list = data || [];
                if (!list.length) { this.$Message('暂无数据可导出'); return; }
                const head = ['期间', '员工姓名', '状态', '应发工资', '免税收入', '年金', '商业健康保险', '税延养老保险', '其他', '养老保险', '医疗保险', '工伤保险', '失业保险费', '公积金缴纳', '个人所得税', '实发工资', '备注'];
                const rows = list.map(it => [
                    it.period, it.employeeName, it.status === 1 ? '已生成凭证' : '草稿',
                    it.grossPay, it.taxFreeIncome, it.annuity, it.commercialHealth, it.taxDeferred, it.other,
                    it.pension, it.medical, it.injury, it.unemployment, it.housingFund, it.personalIncomeTax, it.netPay, it.remark
                ]);
                exportXls({ name: '工资信息', sheets: [{ name: '工资信息', head, rows, widths: [80, 100, 80, 110, 110, 90, 120, 120, 90, 100, 100, 100, 110, 110, 110, 110, 160], types: head.map(() => 's') }] });
            });
        },
        notOpen(name) { this.$Message.info(`${name}功能暂未开放`); }
    },
    watch: {
        showCustom(v) { if (v) this.loadCustom(); },
        showGen(v) { if (v) this.$api.salary.salary.employees().then(({ data }) => { this.employeeOptions = data || []; }); }
    },
    mounted() { this.loadList(); }
};
</script>

<style scoped lang="less">
.filter-bar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
    .label { margin-left: 6px; }
    .flex-spacer { flex: 1; }
    .input-small { width: 150px; height: 30px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 8px; }
}
.grid { width: 100%; border-collapse: collapse; margin-top: 10px;
    th, td { padding: 0 8px; border: 1px solid #e2e2e2; font-size: 12px; height: 32px; white-space: nowrap; }
    th { background-color: #f5f5f5; text-align: center; font-weight: bold; height: 35px; }
    .num { text-align: right; }
    .strong { font-weight: bold; color: #e23c3c; }
    tbody tr:nth-child(even) { background-color: #fafafa; }
    tbody tr:hover { background-color: #f0f6ff; }
    .total td { background-color: #f5f5f5; font-weight: bold; }
}
.actions span { margin-right: 8px; cursor: pointer; color: #3b91ff; }
.tip { color: #999; font-size: 12px; margin: 4px 0 0; }
</style>
